import sendForm from '@scripts/modules/sendForm/sendForm';

const RECAPTCHA_KEY = '6Le8wBIqAAAAABBYrjYPoXdz_G6_jxt2FTT9ilkn'

const popupFormTitle = document.querySelector('#getInTouch .form-title')
const popupFormSubject = document.querySelector('#getInTouch .ui-form [type="hidden"]')

document.querySelectorAll('.btn_form').forEach(item => {
   item.addEventListener('click', function () {
      let attrName = this.dataset.name
      let attrTitle = this.dataset.title

      if (attrName && attrTitle) {
         popupFormTitle.innerText = attrTitle
         popupFormSubject.value = `PRO-PPE.RU: ${attrName}`
      } else {
         popupFormTitle.innerText = 'Свяжитесь с нами'
         popupFormSubject.value = 'Сообщение из формы'
      }
   })
})


document.querySelectorAll('.ui-form').forEach(form => {
   form.addEventListener('submit', e => e.preventDefault())

   form.querySelector('[type="submit"]')?.addEventListener('click', function () {
      grecaptcha.ready(function () {
         grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
            sendForm(form, token);
         });
      });
   })
})
